import defineMessages from "../../../common/helpers/defineMessages";

const messages: {[prop: string]: { id: string }} = defineMessages({
    title: {
        id: "help.moderation.title",
    },
    description: {
        id: "help.moderation.description",
    },
    "non-infringement": {
        id: "testModeration.categories.non-infringement",
    },
    "not-redundant": {
        id: "testModeration.categories.not-redundant",
    },
    cover: {
        id: "testModeration.categories.cover",
    },
    spelling: {
        id: "testModeration.categories.spelling",
    },
    "evaluable-description": {
        id: "testModeration.categories.evaluable-description",
    },
    "score-misprint": {
        id: "testModeration.categories.score-misprint",
    },
    "score-layout": {
        id: "testModeration.categories.score-layout",
    },
    pedagogy: {
        id: "testModeration.categories.pedagogy",
    },
    properties: {
        id: "testModeration.categories.properties",
    },
    level: {
        id: "testModeration.categories.level",
    },

    "non-infringementDescription": {
        id: "moderationCategory.non-infringement.description",
    },
    "not-redundantDescription": {
        id: "moderationCategory.not-redundant.description",
    },
    coverDescription: {
        id: "moderationCategory.cover.description",
    },
    spellingDescription: {
        id: "moderationCategory.spelling.description",
    },
    "evaluable-descriptionDescription": {
        id: "moderationCategory.evaluable-description.description",
    },
    "score-misprintDescription": {
        id: "moderationCategory.score-misprint.description",
    },
    "score-layoutDescription": {
        id: "moderationCategory.score-layout.description",
    },
    pedagogyDescription: {
        id: "moderationCategory.pedagogy.description",
    },
    propertiesDescription: {
        id: "moderationCategory.properties.description",
    },
    levelDescription: {
        id: "moderationCategory.level.description",
    },
});

export default messages;
